'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UIIcon = require('../../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _OptionTypes = require('../../types/OptionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UITypeaheadResultsGroup',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    group: _OptionTypes.OptionGroupType.isRequired
  },

  getLabel: function getLabel() {
    var _props$group = this.props.group,
        text = _props$group.text,
        value = _props$group.value;

    return text || value && value.toString();
  },
  getTitle: function getTitle() {
    var title = this.props.group.title;

    return title || this.getLabel();
  },
  getClassName: function getClassName() {
    var dropdownClassName = this.props.group.dropdownClassName;

    return (0, _reactUtils.classNames)('small-caps', 'truncate-text', 'private-typeahead-results-group__label', dropdownClassName);
  },
  renderIcon: function renderIcon() {
    var icon = this.props.group.icon;

    if (!icon) {
      return null;
    }
    return _react2.default.createElement(_UIIcon2.default, { name: icon });
  },
  render: function render() {
    var children = this.props.children;

    return _react2.default.createElement(
      'li',
      { className: 'private-typeahead-results-group', role: 'presentation' },
      _react2.default.createElement(
        'div',
        {
          className: this.getClassName(),
          role: 'option',
          title: this.getTitle()
        },
        this.renderIcon(),
        ' ',
        this.getLabel()
      ),
      _react2.default.createElement(
        'ul',
        {
          className: 'private-typeahead-results-group__list list-unstyled',
          role: 'listbox'
        },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/typeahead/results/UITypeaheadResultsGroup.js
// module id = 156
// module chunks = 0